<template>
  <div class="lineChart" :id="'lineChart' + chartIndex"></div>
</template>

<script>
import * as echarts from 'echarts';
import { toRefs, computed, onMounted, watch, onBeforeUnmount } from 'vue';
import { getThemeColor } from '@/utils/addColor.js';

export default {
  props: {
    data: {
      type: Array,
      default: () => { []; },
    },
    chartIndex: Number
  },
  setup (props) {
    const { data } = toRefs(props);
    let myChart = {};
    const themStyles = getThemeColor();
    const lineOptions = computed(() => {
      return {
        tooltip: {
          trigger: 'axis',
          backgroundColor: '#11151ee5',
          padding: 16,
          textStyle: {
            color: '#eaedff'
          },
          extraCssText: 'border: 1px dotted #eaedff99'
        },
        grid: {
          left: '0',
          right: '5%',
          bottom: '5%',
          top: '8%',
          containLabel: true,
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          nameTextStyle: {
            color: '#9FA2B1',
            fontSize: 12
          },
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          data: data.value.map(item => item.name)
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            formatter: '{value} %',
            color: 'rgba(234, 237, 255, 0.65)'
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.1)'
            }
          }
        },
        series: [{
          name: '留存率',
          type: 'line',
          itemStyle: {
            color: '#eaedff',
            borderColor: '#ffffff54'
          },
          lineStyle: {
            color: themStyles['--dataAnalysisLines']['line']
          },
          smooth: true,
          areaStyle: {
            color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
              {
                offset: 0,
                color: `rgba(${themStyles['--dataAnalysisLines']['bg']}, 0)`

              },
              {
                offset: 1,
                color: `rgba(${themStyles['--dataAnalysisLines']['bg']}, 0.4)`
              }
              // {
              //   offset: 0,
              //   color: 'rgba(255, 115, 102, 0)'
              // },
              // {
              //   offset: 1,
              //   color: 'rgba(255, 115, 102, 0.4)'
              // }
            ])
          },
          data: data.value.map(item => item.value)
        }]
      };
    });

    function lineChart () {
      let lineChart = echarts.getInstanceByDom(document.getElementById('lineChart' + props.chartIndex));
      if (lineChart == null) {
        lineChart = echarts.init(document.getElementById('lineChart' + props.chartIndex));
      }
      lineChart.setOption(lineOptions.value);
      myChart = lineChart;
    }

    const resizeChart = () => {
      myChart.resize();
    };

    onMounted(() => {
      lineChart();
      window.addEventListener(
        "resize", resizeChart
      );
    });

    onBeforeUnmount(() => {
      window.removeEventListener(
        "resize", resizeChart
      );
    });

    // 监听传值，刷新图表
    watch(data, () => {
      lineChart();
    });

  },
}
</script>

<style scoped lang="less">
.lineChart {
  width: 100%;
  height: 100%;
}
</style>
